module.exports = __webpack_public_path__ + "img/compass.bf25bec5.png";